import { createSlice } from "@reduxjs/toolkit";

const userRecipes = createSlice({
  name: "userRecipes",
  initialState: {
    manualRecipes: { loading: true, data: [] },
    webRecipes: { loading: true, data: [] },
    favoriteRecipes: { loading: true, data: [] },
    convertedRecipes: { loading: true, data: [] },
    editedRecipes: { loading: true, data: [] },
    cartRecipes: {
      loading: true,
      data: {},
      noOfRecipes: 0,
      cartRoute: "/cart",
    },
  },
  reducers: {
    setUserRecipes(state, action) {
      console.log("data", action.payload);
      state[`${action.payload.recipeType}Recipes`].data = action.payload.data;
      state[`${action.payload.recipeType}Recipes`].loading = false;
    },
    appendUserRecipes(state, action) {
      const recipe = state[`${action.payload.recipeType}Recipes`];
      recipe.data =
        recipe.data.length > 0
          ? [...recipe.data, action.payload.data]
          : [action.payload.data];
      recipe.loading = false;
    },
    deleteUserRecipe(state, action) {
      state[`${action.payload.recipeType}Recipes`].data = state[
        `${action.payload.recipeType}Recipes`
      ].data.filter((item) => item.id !== action.payload.data.id);
    },
    updateUserRecipe(state, action) {
      state[`${action.payload.recipeType}Recipes`].data = state[
        `${action.payload.recipeType}Recipes`
      ].data.map((item) => {
        if (item.id === action.payload.data.id) {
          return action.payload.data;
        } else return item;
      });
    },
    setCartRecipesLoading(state, action) {
      state.cartRecipes.loading = action.payload;
    },
    setCartRecipes(state, action) {
      state.cartRecipes.data = action.payload.cartRecipes;
      state.cartRecipes.noOfRecipes = action.payload.noOfRecipes;
      state.cartRecipes.cartRoute = action.payload.cartRoute;
      state.cartRecipes.loading = false;
    },
    addCartRecipe(state, action) {
      const { yy, mm, dd, cartRecipe } = action.payload;
      const dateKey = `${yy}-${mm}-${dd}`;
      const recipeKey = `${cartRecipe.id}${cartRecipe.title
        .toLowerCase()
        .replace(/ /g, "-")}`;

      // Get existing cart data for the date
      const existingDateData = state.cartRecipes.data[dateKey] || {
        checked: false,
        items: {},
      };

      // Create new cart data structure
      const newCartData = {
        [dateKey]: {
          ...existingDateData,
          items: {
            ...existingDateData.items,
            [recipeKey]: {
              data: cartRecipe,
              checked: false,
              ingredients: {
                data: cartRecipe.extendedIngredients
                  ? cartRecipe.extendedIngredients.map((ingredient) => ({
                      ...ingredient,
                      checked: false,
                    }))
                  : [],
                checked: false,
              },
            },
          },
        },
      };

      // Merge with existing cart data
      state.cartRecipes.data = {
        ...state.cartRecipes.data,
        ...newCartData,
      };
      state.cartRecipes.noOfRecipes = state.cartRecipes.noOfRecipes + 1;
    },
    updateCartRecipes(state, action) {
      state.cartRecipes.data = action.payload;
    },
    deleteCartRecipe(state, action) {
      state.cartRecipes.data = action.payload;
      state.cartRecipes.noOfRecipes = state.cartRecipes.noOfRecipes - 1;
    },
  },
});

export const userRecipesActions = userRecipes.actions;
export const userRecipesReducer = userRecipes.reducer;
